import { HttpClient } from '../../httpClient'
import type { OpalApi } from '../../schema'

type ReadPlanningStatusesV3 = OpalApi<'ReadPlanningStatusesV3', 200>

export const readPlanningStatuses: ReadPlanningStatusesV3 = async () => {
  const url = new URL('/planning_statuses/v3', window.location.origin)

  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}
